// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tinyCME body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 1.4;
  margin: 1rem;
}

.tinyCME table {
  border-collapse: collapse;
}

/* Apply a default padding if legacy cellpadding attribute is missing */
.tinyCME table:not([cellpadding]) th,
.tinyCME table:not([cellpadding]) td {
  paddck-table-resizedtinying: 0.4rem;
}

/* Set default table styles if a table has a positive border attribute
     and no inline css */
.tinyCME table[border]:not([border="0"]):not([style*=border-width]) th,
.tinyCME table[border]:not([border="0"]):not([style*=border-width]) td {
  border-width: 1px;
}

/* Set default table styles if a table has a positive border attribute
     and no inline css */
.tinyCME table[border]:not([border="0"]):not([style*=border-style]) th,
.tinyCME table[border]:not([border="0"]):not([style*=border-style]) td {
  border-style: solid;
}

/* Set default table styles if a table has a positive border attribute
     and no inline css */
.tinyCME table[border]:not([border="0"]):not([style*=border-color]) th,
.tinyCME table[border]:not([border="0"]):not([style*=border-color]) td {
  border-color: #ccc;
}

.tinyCME figure {
  display: table;
  margin: 1rem auto;
}

.tinyCME figure figcaption {
  color: #999;
  display: block;
  margin-top: 0.25rem;
  text-align: center;
}

.tinyCME hr {
  border-color: #ccc;
  border-style: solid;
  border-width: 1px 0 0 0;
}

.tinyCME code {
  background-color: #e8e8e8;
  border-radius: 3px;
  padding: 0.1rem 0.2rem;
}

.tinyCME .mce-content-body:not([dir=rtl]) blockquote {
  border-left: 2px solid #ccc;
  margin-left: 1.5rem;
  padding-left: 1rem;
}

.tinyCME .mce-content-body[dir=rtl] blockquote {
  border-right: 2px solid #ccc;
  margin-right: 1.5rem;
  padding-right: 1rem;
}

strong {
  font-weight: bold;
}

b {
  font-weight: bold;
}

em {
  font-style: italic;
}

i {
  font-style: italic;
}

u {
  text-decoration: underline;
}

s {
  text-decoration: line-through;
}

strike {
  text-decoration: line-through;
}

del {
  text-decoration: line-through;
}

ins {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/TemplateDisplay/TinyCME.scss"],"names":[],"mappings":"AAAA;EACE,wIAAA;EAEA,gBAAA;EACA,YAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AACA,uEAAA;AACA;;EAEE,mCAAA;AAEF;;AAAA;wBAAA;AAEA;;EAEE,iBAAA;AAGF;;AADA;wBAAA;AAEA;;EAEE,mBAAA;AAIF;;AAFA;wBAAA;AAEA;;EAEE,kBAAA;AAKF;;AAHA;EACE,cAAA;EACA,iBAAA;AAMF;;AAJA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AALA;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;AAQF;;AANA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;AASF;;AAPA;EACE,2BAAA;EACA,mBAAA;EACA,kBAAA;AAUF;;AARA;EACE,4BAAA;EACA,oBAAA;EACA,mBAAA;AAWF;;AARA;EACE,iBAAA;AAWF;;AARA;EACE,iBAAA;AAWF;;AARA;EACE,kBAAA;AAWF;;AARA;EACE,kBAAA;AAWF;;AARA;EACE,0BAAA;AAWF;;AARA;EACE,6BAAA;AAWF;;AARA;EACE,6BAAA;AAWF;;AARA;EACE,6BAAA;AAWF;;AARA;EACE,0BAAA;AAWF","sourcesContent":[".tinyCME body {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  line-height: 1.4;\n  margin: 1rem;\n}\n.tinyCME table {\n  border-collapse: collapse;\n}\n/* Apply a default padding if legacy cellpadding attribute is missing */\n.tinyCME table:not([cellpadding]) th,\n.tinyCME table:not([cellpadding]) td {\n  paddck-table-resizedtinying: 0.4rem;\n}\n/* Set default table styles if a table has a positive border attribute\n     and no inline css */\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-width\"]) th,\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-width\"]) td {\n  border-width: 1px;\n}\n/* Set default table styles if a table has a positive border attribute\n     and no inline css */\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-style\"]) th,\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-style\"]) td {\n  border-style: solid;\n}\n/* Set default table styles if a table has a positive border attribute\n     and no inline css */\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-color\"]) th,\n.tinyCME table[border]:not([border=\"0\"]):not([style*=\"border-color\"]) td {\n  border-color: #ccc;\n}\n.tinyCME figure {\n  display: table;\n  margin: 1rem auto;\n}\n.tinyCME figure figcaption {\n  color: #999;\n  display: block;\n  margin-top: 0.25rem;\n  text-align: center;\n}\n.tinyCME hr {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 1px 0 0 0;\n}\n.tinyCME code {\n  background-color: #e8e8e8;\n  border-radius: 3px;\n  padding: 0.1rem 0.2rem;\n}\n.tinyCME .mce-content-body:not([dir=\"rtl\"]) blockquote {\n  border-left: 2px solid #ccc;\n  margin-left: 1.5rem;\n  padding-left: 1rem;\n}\n.tinyCME .mce-content-body[dir=\"rtl\"] blockquote {\n  border-right: 2px solid #ccc;\n  margin-right: 1.5rem;\n  padding-right: 1rem;\n}\n\nstrong {\n  font-weight: bold;\n}\n\nb {\n  font-weight: bold;\n}\n\nem {\n  font-style: italic;\n}\n\ni {\n  font-style: italic;\n}\n\nu {\n  text-decoration: underline;\n}\n\ns {\n  text-decoration: line-through;\n}\n\nstrike {\n  text-decoration: line-through;\n}\n\ndel {\n  text-decoration: line-through;\n}\n\nins {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
